import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// yuufood.com/order?t=<โต๊ะ> = หน้าสั่งอาหารของลูกค้าที่สแกน QR ที่โต๊ะ (ไม่ผ่าน LINE/LIFF เลย)
// แยกโหลดคนละก้อน: ลูกค้าไม่ต้องโหลดแอปร้านทั้งแอป และแอปร้านไม่ถ่วงด้วยหน้าลูกค้า
const isCustomerOrderPage = /^\/order\/?$/.test(window.location.pathname);
// yuufood.com/r?k=<รหัส> = ใบเสร็จที่ลูกค้าสแกนจาก QR ท้ายใบเสร็จ (ไม่ผ่าน LINE เช่นกัน)
const isPublicReceiptPage = /^\/r\/?$/.test(window.location.pathname);
const App = React.lazy(() => import('./App'));
const DemoBanner = React.lazy(() => import('./components/DemoBanner'));
const SandboxBanner = React.lazy(() => import('./components/SandboxBanner'));
const CustomerOrder = React.lazy(() => import('./components/CustomerOrder'));
const PublicReceipt = React.lazy(() => import('./components/PublicReceipt'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div style={{ minHeight: '100vh', background: isPublicReceiptPage ? '#F3F1EA' : isCustomerOrderPage ? '#FBFAF6' : 'var(--bg-app)' }} />}>
      {isPublicReceiptPage ? <PublicReceipt /> : isCustomerOrderPage ? <CustomerOrder /> : (<><DemoBanner /><SandboxBanner /><App /></>)}
    </Suspense>
  </React.StrictMode>
);
